import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { ContentProvider } from './context/ContentContext';
import Header from './components/Header';
import Footer from './components/Footer';
import MusicPlayer from './components/MusicPlayer';
import Home from './pages/Home';
import Artists from './pages/Artists';
import Element45Overview from './pages/Element45Overview';
import Element45 from './pages/Element45';
import Store from './pages/Store';
import './App.css';

function App() {
  const [currentTrack, setCurrentTrack] = useState(null);

  return (
    <BrowserRouter>
      <ContentProvider>
        <div className="App min-h-screen bg-black text-white">
          <Toaster position="top-right" />
          <Header />

          <main>
            <Routes>
              <Route path="/" element={<Home setCurrentTrack={setCurrentTrack} />} />
              <Route path="/artists" element={<Artists setCurrentTrack={setCurrentTrack} />} />
              <Route path="/element45" element={<Element45Overview />} />
              <Route path="/element45/olah-bliss" element={<Element45 setCurrentTrack={setCurrentTrack} />} />
              <Route path="/store" element={<Store />} />
            </Routes>
          </main>

          <Footer />
          <MusicPlayer currentTrack={currentTrack} />
        </div>
      </ContentProvider>
    </BrowserRouter>
  );
}

export default App;
